<template>
  <div class="property-info-component">
    <div class="hidden sm:block">
      <span class="text-xl font-medium text-black">
        Información de la Propiedad
      </span>
    </div>
    <!-- Descripción -->
    <div v-if="description != '<p> </p>'" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('descripcion')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Descripción</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.descripcion ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.descripcion"
          class="p-4 border-b border-gray-200"
        >
          <div class="relative w-full">
            <div v-if="!showFullDescription">
              <span>{{ descriptionTruncated }}</span>
            </div>
            <div v-else v-html="description" />
            <button
              v-if="descriptionPlain.length > maxDescriptionLength"
              @click="showFullDescription = !showFullDescription"
              class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
            >
              {{ showFullDescription ? 'Ver menos' : 'Ver más' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:flex lg:flex-wrap mt-8 pb-8 border-b border-[#E5E7EB]">
        <FwbHeading tag="h3" class="font-medium text-xl mb-4">
          Descripción
        </FwbHeading>
        <div class="relative w-full">
          <div v-if="!showFullDescription">
            <span>{{ descriptionTruncated }}</span>
          </div>
          <div v-else v-html="description" />
          <button
            v-if="descriptionPlain.length > maxDescriptionLength"
            @click="showFullDescription = !showFullDescription"
            class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
          >
            {{ showFullDescription ? 'Ver menos' : 'Ver más' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Otras características -->
    <div v-if="characters_additional != '<p> </p>' && characters_additional != null" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('otras_caracteristicas')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Otras características</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.otras_caracteristicas ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.otras_caracteristicas"
          class="p-4 border-b border-gray-200"
        >
          <div class="relative w-full">
            <div v-if="!showFullCharacteristics">
              <span>{{ characteristicsTruncated }}</span>
            </div>
            <div v-else v-html="characters_additional" />
            <button
              v-if="characteristicsPlain.length > maxCharacteristicsLength"
              @click="showFullCharacteristics = !showFullCharacteristics"
              class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
            >
              {{ showFullCharacteristics ? 'Ver menos' : 'Ver más' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:flex lg:flex-wrap mt-8 pb-8 border-b border-[#E5E7EB]">
        <FwbHeading 
          v-show="characters_additional != null"
          class="font-medium text-xl mb-4"
        > 
          Otras características 
        </FwbHeading>
        <div class="relative w-full">
          <div v-if="!showFullCharacteristics">
            <span>{{ characteristicsTruncated }}</span>
          </div>
          <div v-else v-html="characters_additional" />
          <button
            v-if="characteristicsPlain.length > maxCharacteristicsLength"
            @click="showFullCharacteristics = !showFullCharacteristics"
            class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
          >
            {{ showFullCharacteristics ? 'Ver menos' : 'Ver más' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Amenidades -->
    <div v-if="amenities_list.length > 0" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('amenidades')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Amenidades</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.amenidades ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.amenidades"
          class="p-4 border-b border-gray-200"
        >
          <CardAmenitiesComponent :list="amenities_list" />
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:block" id="amenidades">
        <CardAmenitiesComponent :list="amenities_list" />
      </div>
    </div>

    <!-- Friendly -->
    <div v-if="friendly_list.length > 0" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('friendly')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Pet Friendly</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.friendly ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.friendly"
          class="p-4 border-b border-gray-200"
        >
          <CardFriendlyComponent :list="friendly_list" />
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:block" id="friendly">
        <CardFriendlyComponent :list="friendly_list" />
      </div>
    </div>

    <!-- Requirements -->
    <div v-if="requirements_list.length > 0" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('requirements')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Requisitos</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.requirements ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.requirements"
          class="p-4 border-b border-gray-200"
        >
          <CardRequirementComponent :list="requirements_list" />
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:block" id="requirement">
        <CardRequirementComponent :list="requirements_list" />
      </div>
    </div>

    <!-- Services -->
    <div v-if="services_list.length > 0" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('services')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Servicios</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.services ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.services"
          class="p-4 border-b border-gray-200"
        >
          <CardServicesComponent :list="services_list" />
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:block" id="services">
        <CardServicesComponent :list="services_list" />
      </div>
    </div>

    <!-- Video -->
    <div v-if="property.video_url" class="section-block">
      <!-- Móvil - Accordion -->
      <div class="block lg:hidden border-b border-gray-200">
        <button 
          @click="toggleAccordion('videos')"
          class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
        >
          <span>Videos</span>
          <svg 
            :class="['w-4 h-4 transition-transform duration-200', accordionStates.videos ? 'rotate-0' : '']"
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
          >
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
          </svg>
        </button>
        <div 
          v-show="accordionStates.videos"
          class="p-4 border-b border-gray-200"
        >
          <CardVideoComponent :property="property" />
        </div>
      </div>

      <!-- Desktop - Sección normal -->
      <div class="hidden lg:block border-b border-gray-200" id="videos">
        <CardVideoComponent :property="property" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { FwbHeading } from 'flowbite-vue'
import CardAmenitiesComponent from './CardAmenitiesComponent.vue'
import CardFriendlyComponent from './CardFriendlyComponent.vue'
import CardRequirementComponent from './CardRequirementComponent.vue'
import CardServicesComponent from './CardServicesComponent.vue'
import CardVideoComponent from './CardVideoComponent.vue'

const props = defineProps({
  description: {
    type: String,
    default: ''
  },
  characters_additional: {
    type: String,
    default: ''
  },
  amenities_list: {
    type: Array,
    default: () => []
  },
  friendly_list: {
    type: Array,
    default: () => []
  },
  requirements_list: {
    type: Array,
    default: () => []
  },
  services_list: {
    type: Array,
    default: () => []
  },
  videos_list: {
    type: Array,
    default: () => []
  },
  property: {
    type: Object,
    default: () => ({})
  }
})

// Estados para accordions móviles
const accordionStates = ref({
  descripcion: false,
  otras_caracteristicas: false,
  amenidades: false,
  friendly: false,
  requirements: false,
  services: false,
  videos: false
})

// Estados para mostrar contenido completo
const showFullDescription = ref(false)
const showFullCharacteristics = ref(false)

// Constantes para truncado
const maxDescriptionLength = 450
const maxCharacteristicsLength = 450

// Funciones auxiliares
function stripHtml(html) {
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text
  let truncated = text.slice(0, maxLength)
  if (text[maxLength] !== ' ' && truncated.lastIndexOf(' ') > 0) {
    truncated = truncated.slice(0, truncated.lastIndexOf(' '))
  }
  return truncated + '...'
}

// Computed properties
const descriptionPlain = computed(() => stripHtml(props.description || ''))
const descriptionTruncated = computed(() => truncateText(descriptionPlain.value, maxDescriptionLength))

const characteristicsPlain = computed(() => stripHtml(props.characters_additional || ''))
const characteristicsTruncated = computed(() => truncateText(characteristicsPlain.value, maxCharacteristicsLength))

// Función para toggle de accordions
function toggleAccordion(section) {
  accordionStates.value[section] = !accordionStates.value[section]
}
</script>

<style scoped>
/* Componente para información de la propiedad */
</style>
